import { createContext } from "react"

// these are provided as url params
export interface OauthAuthorizeContextValue {
  client_id: string;
  code_challenge?: string;
  code_challenge_method?: string;
  redirect_uri: string;
  response_type: string;
  scope: string;
  state: string;
  p?: string; // device identifier
  device_type?: string;
  country_code?: string;
  tracking_technology_consent_response_value?: string; // "accepted" | "rejected"
  tracking_technology_consent_response_updated_at?: string; // date iso string
}

type ContextType = OauthAuthorizeContextValue | null

export const OauthAuthorizeContext = createContext<ContextType>(null)
